
import Button from '../base/Button';

export default function Footer() {
  return (
    <footer className="bg-crop-black text-crop-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div>
            <h3 className="text-2xl font-gilroy font-bold mb-4">CROP LABS</h3>
            <div className="space-y-4">
              <div>
                <h4 className="font-gilroy font-semibold mb-2 text-crop-white">Endereço:</h4>
                <p className="font-gilroy text-crop-teal leading-relaxed">
                  R. Cel. Fonseca, 894 – Vila São Lúcio<br />
                  Botucatu, SP, Brasil<br />
                  CEP: 18603-495
                </p>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="font-gilroy font-semibold mb-4 text-crop-white">Contato:</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <span className="text-crop-teal">📞</span>
                <a href="tel:+5516997581616" className="font-gilroy text-crop-teal hover:text-crop-white transition-colors">
                  (16) 99758-1616
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-crop-teal">✉️</span>
                <a href="mailto:crop@crop-labs.com" className="font-gilroy text-crop-teal hover:text-crop-white transition-colors">
                  crop@crop-labs.com
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-crop-dark pt-8 text-center">
          <p className="font-gilroy text-crop-teal text-sm">
            © 2024 CROP LABS. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
